'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('jurisdictions', {
      url: '/account/compliance/jurisdictions',
      template: '<jurisdictions></jurisdictions>'
    });
}



// WEBPACK FOOTER //
// ./client/app/account/compliance/jurisdictions/jurisdictions.routes.js